import { useOverlays } from "contexts/OverlayContext";
import { useCallback } from "react";
import { JournalEntryDrawerController } from "./JournalEntryDrawerController";

export const JournalEntryDrawerWrapper = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();

    const overlayInfo =
        getOverlayInfo<"journalEntryDrawer">("journalEntryDrawer");

    const handleHide = useCallback(() => {
        const onClose = overlayInfo?.data?.onClose;
        closeOverlay();
        onClose?.();
    }, [closeOverlay, overlayInfo?.data]);

    if (!overlayInfo?.data) {
        return null;
    }

    return (
        <JournalEntryDrawerController
            key={overlayInfo.instanceId}
            data={overlayInfo.data}
            open={!overlayIsClosing}
            onClose={handleHide}
        />
    );
};
